import httpClient from "@plugins/http";
import {
  SearchFilterCountRequest,
  SearchFilterCountResponse,
} from "@modules/resource-search/resource-search-types.ts";
import { ApiResponse } from "@apis/api.ts";

const search = (requestData, cancelToken) => {
  return httpClient.post(`/apis/search`, requestData, {
    cancelToken: cancelToken,
  });
};

const searchFilterCount = async (
  requestData: SearchFilterCountRequest,
): Promise<ApiResponse<SearchFilterCountResponse>> => {
  return await httpClient.post(`/apis/search/filter-count`, requestData);
};

export default {
  search,
  searchFilterCount,
};
